export const TRANSLATIONS_PT_HOME_QUALITY_AND_ALERTS = {
  "home.qaHarness.card.formDetail": "Detail with form",
  "home.qaHarness.card.reevaluationFeedback": "Reevaluation queued",
  "home.qaHarness.card.inspectionFeedback": "Inspection-only result",
  "home.qaHarness.card.acknowledgedFeedback": "Business action acknowledged",
  "home.qaHarness.card.manualCompletionFeedback": "Manual completion confirmed",
  "home.qaHarness.card.replayFeedback": "Replay result",
  "home.alerts.title": "Requer sua atencao",
  "home.alerts.viewAll": "Ver todos",
  "home.alerts.empty": "Nao ha alertas ativos.",
  "home.alerts.loading": "Carregando...",
  "home.alerts.errorMessage": "Nao foi possivel carregar os alertas.",
  "home.alerts.retry": "Tentar novamente",
};
